import { render } from "./tutorAdmin.vue?vue&type=template&id=4a3d1bc4"
import script from "./tutorAdmin.vue?vue&type=script&lang=js"
export * from "./tutorAdmin.vue?vue&type=script&lang=js"

import "./tutorAdmin.vue?vue&type=style&index=0&id=4a3d1bc4&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__